const cutText = (text: string, maxLength: number | undefined = 500) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength);
};

export default cutText;
